/* global $, data */
/* eslint-disable no-use-before-define */
import Table from 'bam-node-savant-table/table'
import { guff } from 'bam-node-baseball-savant/utils/guff'

data.forEach((d) => {
    const tableDivId = d.tableName
    $(document).ready(() => {
        $('form').submit(false)

        if (d.data && d.data.length > 0) {
            const dataLoad = d.data

            const headers = [
                {
                    name: `<a class="th-glossary-link" style="top: 0px;" href=${d.href} target="_blank">[glossary]</a><a class="th-glossary-link" style="top: 0px; left: 5px;" href=${d.leaderboard} target="_blank">[leaderboard]</a>`,
                    field: d.column,
                    headerClass: 'th-component-header align-left',
                    fieldClass: 'tr-data align-left',
                    sortable: false,
                },
                {
                    name: d.countColumn,
                    field: 'count',
                    type: 'number',
                    headerClass: 'th-component-header align-left',
                    fieldClass: 'tr-data align-left',
                    sortable: false,
                    displayFn: (val) => val.toLocaleString(),
                },
                {
                    name: '%',
                    field: 'percent',
                    type: 'number',
                    headerClass: 'th-component-header align-left',
                    fieldClass: 'tr-data align-left',
                    sortable: false,
                    displayFn: (val) => guff(val, 'metric-percent'),
                },
                {
                    name: 'Season',
                    field: 'year',
                    type: 'number',
                    headerClass: 'th-component-header',
                    fieldClass: 'tr-data',
                    sortable: false,
                },
                {
                    name: 'BA',
                    field: 'ba',
                    type: 'number',
                    headerClass: 'th-component-header',
                    fieldClass: 'tr-data',
                    defaultSortDir: 'desc',
                    displayFn: (val) => guff(val, 'ba'),
                    sortable: false,
                    highlight: [0.2, 0.24, 0.33],
                },
                {
                    name: 'SLG',
                    field: 'slg',
                    type: 'number',
                    headerClass: 'th-component-header',
                    fieldClass: 'tr-data',
                    defaultSortDir: 'desc',
                    displayFn: (val) => guff(val, 'slg'),
                    sortable: false,
                    highlight: [0.25, 0.4, 0.6],
                },
                {
                    name: 'wOBA',
                    field: 'woba',
                    type: 'number',
                    headerClass: 'th-component-header',
                    fieldClass: 'tr-data',
                    defaultSortDir: 'desc',
                    displayFn: (val) => guff(val, 'woba'),
                    sortable: false,
                    highlight:
                        d.name === 'Fast Swing' ||
                        d.name === 'Ideal Attack Angle'
                            ? [0.25, 0.3, 0.35]
                            : [0.15, 0.35, 0.45],
                },
                {
                    name: 'xwOBA',
                    field: 'xwoba',
                    type: 'number',
                    headerClass: 'th-component-header',
                    fieldClass: 'tr-data',
                    defaultSortDir: 'desc',
                    displayFn: (val) => guff(val, 'xwoba'),
                    sortable: false,
                    highlight:
                        d.name === 'Fast Swing' ||
                        d.name === 'Ideal Attack Angle'
                            ? [0.25, 0.3, 0.35]
                            : [0.15, 0.35, 0.45],
                },
                {
                    name: 'Hard-hit %',
                    field: 'hardhit_percent',
                    type: 'number',
                    headerClass: 'th-component-header',
                    fieldClass: 'tr-data',
                    defaultSortDir: 'desc',
                    displayFn: (val) => guff(val * 100, 'hardhit_percent'),
                    sortable: false,
                    highlight: [0.2, 0.4, 0.6],
                },
            ]

            const width = $(`#${tableDivId}`).outerWidth()
            let repeatHeaders = false
            if (width <= 768) {
                repeatHeaders = 15
            }

            const defaultSort = 'season'
            const defaultSortDirection = 'asc'

            // eslint-disable-next-line no-new, new-cap
            new Table({
                id: tableDivId,
                repeatHeader: repeatHeaders,
                sortClass: 'column-sort',
                headers,
                data: dataLoad,
                defaultSort,
                defaultSortDirection,
                showRank: false,
            })
        } else {
            $('#NoData').html('<h1>No Data Found.</h2>')
        }
    })
})
function getUrl() {
    return `/statcast-metrics-context?startYear=${$(
        '#ddlStartYear'
    ).val()}&endYear=${$('#ddlEndYear').val()}&split=${$(
        '#ddlSplitYears'
    ).val()}`
}
$('#btnUpdate').click(() => {
    window.location.href = getUrl()
})
